
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';


@Component({})
export default class OverlayMenu extends Vue {
   closeOverlayMenu() {
       this.$store.commit("closeOverlayMenu");
   }
}
